"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Light;

var _Light = require("@adobe/react-spectrum-workflow/dist/Light");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Light(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Light.A4uLight, null));
}